import { render, staticRenderFns } from "./LeadsEdit.vue?vue&type=template&id=179698fd&"
import script from "./LeadsEdit.vue?vue&type=script&lang=js&"
export * from "./LeadsEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports